module.exports = __webpack_public_path__ + "static/img/app-slide-show1.20438f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-swfl-wgm/images/app-slide-show1.png
// module id = HJlS
// module chunks = 44